import {useCallback} from "react";

type ReplaceRuleType = {
    search: string | RegExp;
    replace?: string;
};
export function useNormalizedTransformer(rules?: ReplaceRuleType[]) {
    return useCallback((tag?: string): string => {
        if (!tag || !rules) return '';

        return rules.reduce((prev, currentValue) => {
            return prev.replace(currentValue.search as string, currentValue?.replace ?? '')
        }, tag);
    }, [rules])
}